<template>
  <!-- 授权 -->
  <div class="ff_interface">
    <div class="td-header">
      <div class="tdh-left">
        <span class="tdhl-rect-icon" />
        <router-link tag="span" to="/workbench" class="tdhl-title">应用中心</router-link>
        <span class="su-icon-arrow tdhl-arrow-icon" />
        <span class="tdhl-subtitle">访问授权-{{ $route.query.name }}</span>
      </div>
      <router-link tag="span" to="/workbench" class="tdh-right">返回到工作台</router-link>
    </div>
    <aclManage style="margin: 20px; height:calc(100vh - 115px); box-shadow: rgba(39, 56, 70, 0.1) 0px 2px 10px 0px; background: rgb(255, 255, 255);"/>
  </div>
</template>
<script>
import aclManage from './acl-manage'
export default {
  components: {
    aclManage
  }
}
</script>
<style lang="scss" scoped>
.ff_interface {
  .td-header {
    box-sizing: border-box;
    height: auto !important;
    padding: 5px 20px;
    padding-bottom: 0;
    display: flex;
    justify-content: space-between;
    .tdh-left {
      display: flex;
      justify-content: center;
      align-items: center;
      .tdhl-rect-icon {
        margin-right: 4px;
        width: 3px;
        height: 12px;
        background: linear-gradient(
          177deg,
          rgba(97, 193, 190, 1) 0%,
          rgba(51, 148, 225, 1) 100%
        );
      }
      .tdhl-title {
        cursor: pointer;
        margin-right: 4px;
        height: 20px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        color: rgba(98, 111, 121, 1);
        line-height: 20px;
      }
      .tdhl-arrow-icon {
        margin-right: 4px;
        transform: rotate(-90deg);
        font-size: 12px;
        color: #bec9d2;
      }
      .tdhl-subtitle {
        height: 20px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        color: rgba(39, 56, 70, 1);
        line-height: 20px;
      }
    }
    .tdh-right {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #314250;
      border-bottom: 1px solid transparent;
      &:hover {
        border-bottom: 1px solid #314250;
      }
    }
  }
}
</style>
